/** Two-letter label for tab avatar and profile; uses avatar_initials when set, else derives from name. */
export function userTabInitials(user) {
  if (!user) return '?';
  const custom = String(user.avatar_initials ?? '').trim();
  if (custom.length >= 1) {
    return custom.slice(0, 2).toUpperCase();
  }
  const first = String(user.firstname || '').trim();
  const last = String(user.lastname || '').trim();
  if (first && last) {
    return (first[0] + last[0]).toUpperCase();
  }
  if (first.length >= 2) {
    return first.slice(0, 2).toUpperCase();
  }
  if (first.length === 1) {
    return first.toUpperCase();
  }
  if (last.length >= 2) {
    return last.slice(0, 2).toUpperCase();
  }
  if (last.length === 1) {
    return last.toUpperCase();
  }
  const username = String(user.username || '').replace(/[^a-zA-Z0-9]/g, '');
  if (username.length >= 2) {
    return username.slice(0, 2).toUpperCase();
  }
  if (username.length === 1) {
    return username.toUpperCase();
  }
  const local = String(user.email || '').split('@')[0] || '';
  const fromEmail = local.replace(/[^a-zA-Z0-9]/g, '');
  if (fromEmail.length >= 2) {
    return fromEmail.slice(0, 2).toUpperCase();
  }
  if (fromEmail.length === 1) {
    return fromEmail.toUpperCase();
  }
  return '?';
}
